import styles from './Header.module.scss';

const Header = () => {
  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <a href="#">Example links</a>
      </nav>
    </header>
  );
};

export default Header;
